"use client";

import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface FilterToolbarControlsProps {
  label?: ReactNode;
  children: ReactNode;
  className?: string;
  desktopGapClassName?: string;
}

interface FilterToolbarControlProps {
  children: ReactNode;
  spanClassName?: string;
  className?: string;
}

/**
 * Shared responsive filter controls layout:
 * - Mobile: 2-column grid.
 * - Desktop: inline/wrapping row.
 */
export function FilterToolbarControls({
  label,
  children,
  className,
  desktopGapClassName = "sm:gap-3",
}: FilterToolbarControlsProps) {
  const ariaLabel = typeof label === "string" ? label : undefined;

  return (
    <div
      role={ariaLabel ? "group" : undefined}
      aria-label={ariaLabel}
      className={cn(
        "w-full sm:w-auto grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:items-center",
        desktopGapClassName,
        className,
      )}
    >
      {children}
    </div>
  );
}

/**
 * Shared wrapper for individual filter controls that normalizes trigger sizing.
 */
export function FilterToolbarControl({
  children,
  spanClassName = "col-span-1",
  className,
}: FilterToolbarControlProps) {
  return (
    <div
      className={cn(
        spanClassName,
        "min-w-0 sm:min-w-44 [&_button]:h-11 [&_button]:w-full sm:[&_button]:h-10",
        className,
      )}
    >
      {children}
    </div>
  );
}
